import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get MedicationRequest.Search (Signed Medication Order) (R4) data from EHR
 * @param {*} patID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getMedicationRequest(patFHIRID, fhir_server, access_token) {
  var category = "inpatient";
  var orderIDArray = [];

  var date = new Date();
  date.setHours(date.getHours() - 4);
  const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';

  const ehrconfig = await axios.get('ehrconfig.json');
  const EHR_RXNORMS = ehrconfig.data["EHR_RXNORMS"];
  let medicationRequestUrl = ehrconfig.data["EHR_MEDICATION_REQUEST_R4"];
  let medicationUrl = ehrconfig.data["EHR_MEDICATION_R4"];

  let getMedicationRequestSearchUrl = fhir_server + medicationRequestUrl + '?category=' + category + '&patient=' + patFHIRID + '&_include=MedicationRequest:medicationReference&intent=order&date=ge' + isoStringWithoutMs;

  try {
    let response = await axios.get(
      getMedicationRequestSearchUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    //console.log("getMedicationRequest MedicationRequest.Search (Signed Medication Order) (R4) FHIR response: " + JSON.stringify(response.data));

    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      let medItemRefArr = [];
      var medObjArr = []; // Array of Object medFHIRId and code
      var medReqObjArr = []; // Array of Object medFHIRId, orderID, medName
      const ingredientParentFHIRID = {}; //  key: Parent medFHIRID, value: [list of Ingredient medFHIRIDs]

      for (var i= 0; i < entryArray.length; i++) {
        if (entryArray[i].resource !== undefined) {
          let resourceType = entryArray[i].resource.resourceType;
          if (resourceType === "Medication") { // separate function
            if (entryArray[i].resource.code.coding !== undefined) {
              for (var c=0; c < entryArray[i].resource.code.coding.length; c++) {
                if (entryArray[i].resource.code.coding[c].system.includes("rxnorm")) {
                  let code = entryArray[i].resource.code.coding[c].code;
                  if (EHR_RXNORMS.includes(code)) {
                    var medObj = {}; // Object with medFHIRId and code
                    let medFHIRId = entryArray[i].resource.id;
                    medObj.medFHIRId = medFHIRId;
                    medObj.code = code;
                    medObjArr.push(medObj);
                  }
                }
              }
            } else { // Look for ingredient
              if (entryArray[i].resource.ingredient !== undefined) {
                for (var ing=0; ing < entryArray[i].resource.ingredient.length; ing++) {
                  if (entryArray[i].resource.ingredient[ing].itemReference !== undefined) {
                    //console.log(entryArray[i].resource.ingredient[ing].itemReference);
                    let medItemRefId = entryArray[i].resource.ingredient[ing].itemReference.reference.replace("Medication/", "");
                    //console.log(" medItemRefId ----------> " + medItemRefId);
                    medItemRefArr.push(medItemRefId);
                    // Build interest of medication with Ingredient FHIRID and list of Parent medFHIRIDs 
                    let medFHIRId = entryArray[i].resource.id;
                    // Check if the key exists, add the value to the existing array else create a new array for the key
                    if (medItemRefId in ingredientParentFHIRID) {
                      ingredientParentFHIRID[medItemRefId].push(medFHIRId);
                    } else {
                      ingredientParentFHIRID[medItemRefId] = [medFHIRId];
                    }
                  }
                } // end of foreach ingredient
              }
            }
          } // end of if resourceType Medication

          if (resourceType === "MedicationRequest") {
            // Build array of object. Object key: Order ID, Object value: medFHIRId of the MedicationRequest
            if (entryArray[i].resource.medicationReference.reference !== undefined) {
              let medRef = entryArray[i].resource.medicationReference.reference;
              let medFhirId = medRef.replace("Medication/", "");
              let medName = entryArray[i].resource.medicationReference.display;
              //console.log("Medication name: " + medName + " --> " + medFhirId);
              if (Array.isArray(entryArray[i].resource.identifier)) {
                var medReqObj = {};
                var identifierArray = entryArray[i].resource.identifier;
                for (let l=0; l < identifierArray.length; l++) {
                  if (identifierArray[l].system.endsWith("798268")) {
                    medReqObj.medFHIRId = medFhirId;
                    medReqObj.orderID = identifierArray[l].value;
                    medReqObj.medName = medName;
                    medReqObjArr.push(medReqObj);                  
                  }
                }        
              }
            }
          } // end of if resourceType MedicationRequest 
        }
      } // end of for entryArray
      //console.log("medObjArr: " + JSON.stringify(medObjArr));
      //console.log("medReqObjArr: " + JSON.stringify(medReqObjArr));
      //console.log("Build interest of medication: " + JSON.stringify(ingredientParentFHIRID));

      /* Compare medObjArr and medReqObjArr, if medFHIRId matches, get Order ID */
      medObjArr.forEach(medObj => {
        const result = medReqObjArr.find(({ medFHIRId }) => medFHIRId === medObj.medFHIRId);
        //console.log("Order ID returned 1: " + result.orderID + " " + medObj.code);
        let orderIDObj = {};
        orderIDObj.ID = result.orderID;
        orderIDObj.Type = 'Internal';
        orderIDObj.rxnorm = medObj.code;
        orderIDObj.medName = result.medName;
        orderIDArray.push(orderIDObj);
      });

      // Call Medication.Search (R4) with _id parameter  
      if (medItemRefArr && medItemRefArr.length) {
        let uniqueMedItemRefArr = [...new Set(medItemRefArr)];
        //console.log("uniqueMedItemRefArr: " + uniqueMedItemRefArr.toString());

        if (uniqueMedItemRefArr && uniqueMedItemRefArr.length) {
          let getMedicationSearchUrl = fhir_server + medicationUrl + '?_id=' + uniqueMedItemRefArr.toString();
          //let getMedicationSearchUrl = fhir_server + medicationUrl + '?_id=eNcuETrHuDf2W5ZjcTDOG4HGxF3RR5lVe1vFs-5xtSZ83,eZiIZQ2IJrQWTXmqgBMgjMQTgMSlV-LC.3Ajf3GR8Nck3';
          //console.log("getMedicationSearchUrl: " + getMedicationSearchUrl); 
    
          try {
            let searchresponse = await axios.get(
              getMedicationSearchUrl,
              {
                headers:
                {
                  'Authorization': 'Bearer ' + access_token,
                  'Accept': 'application/json'
                }
              });
            //console.log("getMedicationRequest Medication.Search (R4) FHIR response: " + JSON.stringify(searchresponse.data));
            if (searchresponse.data.total > 0) {
              let medEntryArray = searchresponse.data.entry;
              var medObjArr1 = []; // key: code, value: medFHIRId
  
              for (var j= 0; j < medEntryArray.length; j++) {
                if (medEntryArray[j].resource !== undefined) {
                  let medResourceType = medEntryArray[j].resource.resourceType;
                  if (medResourceType === "Medication") { 
                    if (medEntryArray[j].resource.code.coding !== undefined) {
                      for (var k=0; k < medEntryArray[j].resource.code.coding.length; k++) {
                        if (medEntryArray[j].resource.code.coding[k].system.includes("rxnorm")) {
                          let code = medEntryArray[j].resource.code.coding[k].code;
                          if (EHR_RXNORMS.includes(code)) {
                            var medObj1 = {}; // key is RXNORM code, value is medFHIRId
                            let medFHIRId = medEntryArray[j].resource.id;
                            medObj1.medFHIRId = medFHIRId;
                            medObj1.code = code;
                            medObjArr1.push(medObj1);
                          }
                        }
                      }
                    } else { // Look for ingredient ? Unlikely
                      // TODO: Both resource.code.coding and ingredients are SAME.
                    }
                  }
                } 
              } // end of for
              //console.log("medObjArr1: " + JSON.stringify(medObjArr1));
  
              /* Compare medObjArr1 and ingredientParentFHIRID, if medFHIRId matches, get Order ID from medReqObjArr */ 
              var matchedmedFHIRID = [];   
              medObjArr1.forEach(medObj1 => {
                if (ingredientParentFHIRID.hasOwnProperty(medObj1.medFHIRId)) {
                  //console.log("medFHIRID matches with parent : " + medObj1.medFHIRId);
                  //console.log(JSON.stringify(ingredientParentFHIRID[medObj1.medFHIRId]));
                  matchedmedFHIRID = matchedmedFHIRID.concat(ingredientParentFHIRID[medObj1.medFHIRId]);
                } 
              });                
              const uniquematchedArray = [...new Set(matchedmedFHIRID)];
              //console.log("uniquematchedArray: " + JSON.stringify(uniquematchedArray));

              /* Compare medObjArr1 and parentIngredientsFHIRID, if medFHIRId matches, get Order ID */
              uniquematchedArray.forEach(matObj => {
                const result = medReqObjArr.find(({ medFHIRId }) => medFHIRId === matObj);
                //console.log("Order ID returned 2: " + result.orderID + " " + matObj);
                let orderIDObj = {};
                orderIDObj.ID = result.orderID;
                orderIDObj.Type = 'Internal';

                // Get all keys of the object
                const allKeys = Object.keys(ingredientParentFHIRID);

                // Filter the keys where the value array includes the search value
                const parentFHIRIds = allKeys.filter(key => {
                  const valuesArray = ingredientParentFHIRID[key];
                  // Check if the valuesArray is indeed an array and includes the value
                  return Array.isArray(valuesArray) && valuesArray.includes(matObj);
                });
                //console.log("parentFHIRIds: " + parentFHIRIds);

                medObjArr1.forEach(parent => {
                  if(parentFHIRIds.includes(parent.medFHIRId)) {
                    orderIDObj.rxnorm = parent.code;
                    //console.log("RXNORM::: " + parent.code);
                  }
                });
                orderIDObj.medName = result.medName;
                orderIDArray.push(orderIDObj);
              });  
            }
          } catch (searcherr) {
            WriteToLog("Medication.Search (R4) FHIR error: " + searcherr.message);
            return null;
          }
        } // if uniqueMedItemRefArr
      }
      //console.log("getMedicationRequest result: " + JSON.stringify(orderIDArray));
      return orderIDArray;
    } else {
      // EHR value empty if total is 0
      return orderIDArray;
    }
  } catch (error) {
    if (!error.message.includes("401")) { // 401 - Access Token Expired
      WriteToLog("getMedicationRequest FHIR error: " + error.message);
    }
    return null;
  }
}

export default getMedicationRequest;
